import { apiSlice } from './apiSlice';

const SUBSCRIPTION_URL = `${process.env.REACT_APP_BACKEND_URI}/api/v1/subscription`;

export const subscriptionApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSubscription: builder.mutation({
      query: (data) => ({
        url: `${SUBSCRIPTION_URL}/getallsub`,
        method: 'GET',
        body: data,
        credentials: "include",
      }),
    }),
    getSubAdminP: builder.mutation({
      query: (data) => ({
        url: `${SUBSCRIPTION_URL}/admin/getallsub`,
        method: 'GET',
        body: data,
        credentials: "include",
      }),
    }),
    createSubAdminP: builder.mutation({
      query: (data) => ({
        url: `${SUBSCRIPTION_URL}/create`,
        method: 'POST',
        body: data,
        credentials: "include",
      }),
    }),
    updateSubAdminP: builder.mutation({
      query: (data) => ({
        url: `${SUBSCRIPTION_URL}/update`,
        method: 'PUT',
        body: data,
        credentials: "include",
      }),
    }),
    deleteSubAdminP: builder.mutation({
      query: (data) => ({
        url: `${SUBSCRIPTION_URL}/delete`,
        method: 'Delete',
        body: data,
        credentials: "include",
      }),
    }),
    getSubscriptionStats: builder.query({
      query: () => ({
        url: `${SUBSCRIPTION_URL}/subscription-stats`,
        method: 'GET',
        credentials: 'include',
      }),
    }),   
    
  }),
});

// Export the mutation hook for use in components
export const {
  useGetSubscriptionMutation,
  useCreateSubAdminPMutation,
  useUpdateSubAdminPMutation,
  useDeleteSubAdminPMutation,
  useGetSubAdminPMutation,
  useGetSubscriptionStatsQuery
} = subscriptionApiSlice;